import { apiCaller } from '../ApiCaller/ApiCaller';

export async function updateTaskDataOfContact(taskData) {

    const updateTaskData  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/updateTaskDetail", taskData); 
      return updateTaskData;
}

